import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=60abce2f&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"
import style0 from "./Campaign.vue?vue&type=style&index=0&id=60abce2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60abce2f",
  null
  
)

export default component.exports